import React, { FC } from 'react';
import { style } from './style';
import { css } from 'aphrodite/no-important';

const PRODUCT_INFO_MAX_WORDS = 50;
interface Props {
  productTitle: string;
  productInfo: string;
  productReadMoreUrl: string;
  readMoreLabelText: string;
  partnerName?: string;
  onResourceClick?(
    e: React.MouseEvent<HTMLAnchorElement>,
    { productTitle, productReadMoreUrl }: { productTitle: string; productReadMoreUrl: string }
  ): void;
}
export const Product: FC<Props> = ({
  productInfo,
  productTitle,
  productReadMoreUrl,
  readMoreLabelText,
  partnerName,
  onResourceClick,
}) => {
  const styles = style();

  const getProductInfo = (text: string) => {
    const textArray = productInfo.split(' ');

    return textArray.length > PRODUCT_INFO_MAX_WORDS
      ? textArray.slice(0, PRODUCT_INFO_MAX_WORDS).join(' ').concat('&hellip;')
      : text;
  };

  const handleResourceClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onResourceClick) {
      onResourceClick(e, { productTitle, productReadMoreUrl });
    }
  };

  return (
    <article className={css(styles.container)}>
      <span className={css(styles.productTitle)}>{productTitle}</span>
      <div className={css(styles.productInfo)} dangerouslySetInnerHTML={{ __html: getProductInfo(productInfo) }}></div>
      {productReadMoreUrl && (
        <a
          className={css(styles.readMoreLink)}
          onClick={handleResourceClick}
          href={productReadMoreUrl}
          target='_blank'
          rel='noopener noreferrer'>
          {readMoreLabelText}
        </a>
      )}
    </article>
  );
};
